import React from "react";
import { connect } from "react-redux";
import style from "./debugger.module.scss";

function DebuggerWindow(props) {
  if (process.env.REACT_APP_DEV_MODE !== "true") return null;

  const getDebugs = () => {
    let debugsArray = [];
    for (let key in props.debugObject) {
      debugsArray.push(
        <span key={key}>
          {key}: {props.debugObject[key]}
        </span>
      );
    }
    return debugsArray;
  };
  return (
    <div className={`${style.container} position-relative`}>
      <div className={`${style.innerContainer} pr-3 pl-3 d-flex flex-column`}>
        {/*{getDebugs()}*/}
      </div>
    </div>
  );
}

// Redux zum holen der States
const mapStateToProps = (state) => {
  return {
    debugObject: state.debug.debuggingView,
  };
};

export default connect(mapStateToProps)(DebuggerWindow);
